<template>
  <span>{{ currentLocaleDayName }}</span>
</template>

<script>
export default {
  data: function() {
    return {};
  },

  computed: {
    currentLocale() {
      if (navigator.languages != undefined) return navigator.languages[0];
      else return navigator.language;
    },

    currentLocaleDayName() {
      return new Date().toLocaleString(this.currentLocale, { weekday: "long" });
    }
  }
};
</script>

<style></style>
